import React, { useContext, useEffect, useState } from "react";
import "./Latest_updates.css";
import Heading_banner_section from "../../../common_components/heading_banner/Heading_banner_section";
import { useNavigate } from "react-router-dom";
import { luxuryLatestNews } from "../../../../utils/luxuryapis/Home/Homeapi";
import { Context } from "../../../../utils/context";

function Latest_updates() {
  const { IMG_URL } = useContext(Context);
  const [latestnews, setLatestNews] = useState();
  
  const getAllLuxuryLatestNews = async () => {
    const res = await luxuryLatestNews();
    if (res?.success) {
      setLatestNews(res?.data);
    } else {
      console.error("Error fetching  data:", res?.error);
    }
  };

  useEffect(() => {
    getAllLuxuryLatestNews();
  }, []);
  const navigate = useNavigate();
  const breadcrumbItems = [
    { label: "HOME", link: "/luxury/home" },
    { label: "LATEST NEWS" },
  ];
  return (
    <>
      <section className="Latest_updates_holder">
        <Heading_banner_section
          headingText={"LATEST NEWS"}
          breadcrumbItems={breadcrumbItems}
        />
        <div className="custom_container">
          <div className="Latest_updates_section_holder">
            <div className="row">
              {/* below is the first data from the length of latest news */}
              {/* <div className="col-md-8">
                <div
                  className="letest_update_card_holder"
                  onClick={() => navigate("/luxury/latest-news-details")}
                >
                  <div className="img_holder">
                    <img
                      src="/assest/luxury_images/in_company/latest_news/latest_updates/main_img.png"
                      alt="LATEST UPDATES"
                      className="letest_update_img"
                    />
                  </div>

                  <div className="text_holder">
                    <h1>Luxury articles to gift</h1>
                    <p>
                      <b>Antique Collections - </b>Step into history's embrace
                      with our captivating antique collections...
                    </p>
                    <p>
                      Lorem Ipsum is simply dummy text of the printing and
                      typesetting industry. Lorem Ipsum has been the industry's
                      standard dummy text ever since the 1500s, when an unknown
                      printer took a galley of type and scrambled it to make a
                      type specimen book.
                    </p>
                    <div className="date_text_holder">
                      <div className="row">
                        <div className="col-md-6">
                          <p>
                            By <span>Samantha</span> and <span>William</span>{" "}
                          </p>
                        </div>

                        <div className="col-md-6">
                          <div className="date_holder">
                            <p>23 minutes ago</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div> */}
              {latestnews?.length > 0 && (
                <div className="col-md-8">
                  <div
                    className="letest_update_card_holder"
                    onClick={() =>
                      navigate(
                        `/luxury/latest-news-details/${latestnews[0].id}`,
                      )
                    }
                  >
                    <div className="img_holder">
                      <img
                        src={IMG_URL + latestnews[0].image}
                        alt="LATEST UPDATES"
                        className="letest_update_img"
                      />
                    </div>

                    <div className="text_holder">
                      <h1>{latestnews[0].name}</h1>

                      <p>
                        <b>{latestnews[0].by_name} - </b>
                        <span
                          dangerouslySetInnerHTML={{
                            __html: latestnews[0].description,
                          }}
                        />
                      </p>

                      <div className="date_text_holder">
                        <div className="row">
                          <div className="col-md-6">
                            <p>
                              By <span>{latestnews[0].by_name}</span>
                            </p>
                          </div>
                          <div className="col-md-6">
                            <div className="date_holder">
                              <p>
                                {new Date(
                                  latestnews[0].createdAt,
                                ).toLocaleDateString()}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {/* below is the slider part  */}

              {/* <div className="col-md-4">
                <div className="lates_update_list_holder">
                  <div className="letest_update_card_holder">
                    <div className="img_holder">
                      <img
                        src="/assest/luxury_images/in_company/latest_news/latest_updates/img_1.png"
                        alt="LATEST UPDATES"
                        className="letest_update_img"
                      />
                    </div>

                    <div className="text_holder">
                      <h1>Luxury articles to gift antique collections</h1>

                      <div className="date_text_holder">
                        <div className="row">
                          <div className="col-md-6">
                            <p>
                              By <span>Samantha</span> and <span>William</span>{" "}
                            </p>
                          </div>

                          <div className="col-md-6">
                            <div className="date_holder">
                              <p>23 minutes ago</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="letest_update_card_holder">
                    <div className="img_holder">
                      <img
                        src="/assest/luxury_images/in_company/latest_news/latest_updates/img_2.png"
                        alt="LATEST UPDATES"
                        className="letest_update_img"
                      />
                    </div>

                    <div className="text_holder">
                      <h1>Luxury articles to gift</h1>

                      <div className="date_text_holder">
                        <div className="row">
                          <div className="col-md-6">
                            <p>
                              By <span>Samantha</span> and <span>William</span>{" "}
                            </p>
                          </div>

                          <div className="col-md-6">
                            <div className="date_holder">
                              <p>23 minutes ago</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="letest_update_card_holder">
                    <div className="img_holder">
                      <img
                        src="/assest/luxury_images/in_company/latest_news/latest_updates/img_1.png"
                        alt="LATEST UPDATES"
                        className="letest_update_img"
                      />
                    </div>

                    <div className="text_holder">
                      <h1>Luxury articles to gift</h1>

                      <div className="date_text_holder">
                        <div className="row">
                          <div className="col-md-6">
                            <p>
                              By <span>Samantha</span> and <span>William</span>{" "}
                            </p>
                          </div>

                          <div className="col-md-6">
                            <div className="date_holder">
                              <p>23 minutes ago</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="letest_update_card_holder">
                    <div className="img_holder">
                      <img
                        src="/assest/luxury_images/in_company/latest_news/latest_updates/img_2.png"
                        alt="LATEST UPDATES"
                        className="letest_update_img"
                      />
                    </div>

                    <div className="text_holder">
                      <h1>Luxury articles to gift</h1>

                      <div className="date_text_holder">
                        <div className="row">
                          <div className="col-md-6">
                            <p>
                              By <span>Samantha</span> and <span>William</span>{" "}
                            </p>
                          </div>

                          <div className="col-md-6">
                            <div className="date_holder">
                              <p>23 minutes ago</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div> */}
              <div className="col-md-4">
                <div className="lates_update_list_holder">
                  {latestnews?.slice(1).map((item) => (
                    <div
                      key={item.id}
                      className="letest_update_card_holder"
                      onClick={() =>
                        navigate(`/luxury/latest-news-details/${item.id}`, {
                          state: { news: item },
                        })
                      }
                    >
                      <div className="img_holder">
                        <img
                          src={IMG_URL + item.image}
                          alt="LATEST UPDATES"
                          className="letest_update_img"
                        />
                      </div>

                      <div className="text_holder">
                        <h1>{item.name}</h1>

                        <div className="date_text_holder">
                          <div className="row">
                            <div className="col-md-6">
                              <p>
                                By <span>{item.by_name}</span>
                              </p>
                            </div>
                            <div className="col-md-6">
                              <div className="date_holder">
                                <p>
                                  {new Date(
                                    item.createdAt,
                                  ).toLocaleDateString()}
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              {/* here ends the roller  */}
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Latest_updates;
